jQuery(document).ready(function($) {
  var adminBarHeight = 0;
  var screen_admin_min = 783;
  var header = $('[data-elementor-type="header"]');
  var body = $('body');

  // Calculate admin bar
  if (body.hasClass('admin-bar')) {
    if ($(window).width() > screen_admin_min) {
      adminBarHeight = 32;
    } else {
      adminBarHeight = 46;
    }
  }

  // Window events
  var onWindowEvents = function(foo, isReady, isLoad, isResize, isScroll) {
    if (isReady) {
      $(document).ready(foo);
    }

    if (isLoad) {
      $(window).bind('load', foo);
    }

    if (isResize) {
      var throttleResizing = _.throttle(foo, 100);
      $(window).bind('resize', throttleResizing);
    }

    if (isScroll) {
      var throttleScroll = _.throttle(foo, 10);
      $(window).bind('scroll', throttleScroll);
    }
  };

  // Sticky header
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = header.outerHeight();

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
      return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      body.removeClass('nav-down').addClass('nav-up');

      if (st > adminBarHeight + 30) {
        body.addClass('start-sticky');
      }
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        body.removeClass('nav-up').addClass('nav-down');
      }

      if (st < adminBarHeight + 400) {
        body.removeClass('start-sticky');
      }
    }

    lastScrollTop = st;
  }

  // onWindowEvents(hasScrolled, 1, 0, 0, 1);

  $(document).on('click', '.dashicons-search', function(e) {
    e.preventDefault();
  });

  // Balance elements
  var balanceElements = function(container, clr, gapDelta) {
    clr = (typeof clr !== 'undefined' ? clr : false);
    gapDelta = (typeof gapDelta !== 'undefined' ? gapDelta : 120);
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = [],
      el,
      currentDiv,
      topPosition = 0;
    var c = $(container).filter(':visible');
    if (!c.length) {
      return false;
    }
    if (!clr) {
      c.css('height', 'auto');
    } else {
      c.removeAttr('style');
    }
    c.each(function() {
      el = $(this);
      topPosition = el.offset().top;
      if ((currentRowStart < (topPosition + gapDelta)) && (currentRowStart > (topPosition - gapDelta))) {
        rowDivs.push(el);
        currentTallest = (currentTallest < el.outerHeight()) ? (el.outerHeight()) : (currentTallest);
      } else {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].css('height', currentTallest + 'px');
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = el.outerHeight();
        rowDivs.push(el);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].css('height', currentTallest + 'px');
      }
    });
    return true;
  };

  var balanceAll = function() {
    balanceElements($('.balance-elements'), false, 30);
  };

  onWindowEvents(balanceAll, 1, 1, 1, 0);

  window.almComplete = balanceAll;

  $(document).on('click', '.elementor-tab-title', function() {
    setTimeout(balanceAll, 500);
  });

  // Products slider

});
